// eslint-disable-next-line
import git from "../Images/git.jpeg"

const BlogData = [
  {
    title: "GIT COMMANDS",
    description:
      "Hi there! Basically, people are very much less aware of git and Github. I'm sure that won't happen after going through this entire article.",
    published: "May 29, 2023",
    imgsrc: git,
    link: "https://bogeshwararao.hashnode.dev/top-git-commands",
  }
];

export default BlogData;
